import React, { Component } from 'react'
import { Provider } from 'react-redux'
import { applyMiddleware, compose, createStore } from 'redux'
import createSagaMiddleware from 'redux-saga'
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom'
import reducers from '../../reducers/index'
import appRoutes from '../../routes/App'
import rootSaga from '../../sagas/index'
import Header from '../../components/Header'
import FooterPortal from '../../components/FooterPortal'
import { fetchDisclaimers } from '../../sagas/disclaimer'
import { fetchUserInfo } from '../../sagas/appSettings'

const sagaMiddleware = createSagaMiddleware()
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

const store = createStore(reducers, composeEnhancers(applyMiddleware(sagaMiddleware)))
sagaMiddleware.run(fetchUserInfo)
sagaMiddleware.run(fetchDisclaimers)
sagaMiddleware.run(rootSaga)

class App extends Component {
  state = {
    pathName: [],
  }

  componentDidUpdate(e) {
    if (
      window.innerWidth < 993 &&
      e.history &&
      e.history.location.pathname !== e.location.pathname &&
      document.documentElement.className.indexOf('nav-open') !== -1
    ) {
      document.documentElement.classList.toggle('nav-open')
    }
  }

  routeChanged = props => {
    //scroll top top on Route change
    window.scrollTo(0, 0)

    const gtag = window.gtag
    if (window.location.pathname === props.location.pathname) {
      return null
    }
    if (props.history.action === 'PUSH' && typeof gtag === 'function' && window.djconfig.ANALYTICS_ID) {
      gtag('config', window.djconfig.ANALYTICS_ID, {
        page_location: window.location.href,
        page_path: props.location.pathname,
      })
    }

    return null
  }

  render() {
    return (
      <Provider store={store}>
        <div>
          <BrowserRouter>
            <div>
              <Header openNav={this.state.activeKey} />
              <Route path='/' component={this.routeChanged} />
              <Switch>
                {appRoutes.map((prop, key) => {
                  if (prop.redirect) return <Redirect from={prop.path} to={prop.to} key={key} />
                  return <Route exact={prop.exact} path={prop.path} component={prop.component} key={key} />
                })}
              </Switch>
            </div>
          </BrowserRouter>
          <FooterPortal />
        </div>
      </Provider>
    )
  }
}

export default App
